<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="分配名单" :visible.sync="visibleDialog" :before-close="closeDialog" width="800px" :loading="loading">
      <tipBox class="tipbox" :type="'warning'">
        <div>已分配线索再次分配将更换归属人</div>
      </tipBox>
      <p class="mt-16 mb-16">本次共选中 <span style="color: #348CFF;">{{ sumData||0 }}</span> 条名单，其中有 <span style="color: #348CFF;">{{ allocated.length||0 }}</span> 条为已分配状态</p>
      <div class="mb-16">
        <el-cascader ref="cascader" style="width:300px;" filterable popper-class="cascader-department" class="cascader-dept" size="small" placeholder="请选择员工" :key="key" :options="options" :show-all-levels="false"
          :props="props" v-model="value" collapse-tags clearable @change="changeCascader"></el-cascader>
        <span class="ml-10" style="position: relative;top: 8px;color: #999;">分配方式：按照员工顺序轮流分配</span>
      </div>
      <el-table ref="multipleTable" :loading="tableLoading" :data="tableData" tooltip-effect="dark" :key="key" :header-cell-style="{color:'#666',background: 'rgba(52, 140, 255, 0.08)',fontWeight: '400'}">
        <el-table-column prop="sort" label="序号" />
        <el-table-column prop="value" label="员工姓名" show-overflow-tooltip />
        <el-table-column prop="todayDispatchCount" label="今日已分配" />
        <el-table-column prop="disNum" label="本次将分配" />
        <el-table-column prop="name" label="操作">
          <template slot-scope="scope">
            <a style="color: #409EFF;" @click="clickDel(scope.row,scope.$index)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pageNum="pageNum" :pageSize="pageSize" :total="sumList.length" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange"></pagination>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" v-if="sumData>0" :loading="btnLoading" type="primary" @click="batchDispatchLead">确定分配</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { reduceSame } from '@/base/global'
import { batchDispatchLead, getTodayHasDispatched } from '@/views/call/api'
export default {
  name: 'allotDialog',
  props: {
  },
  data() {
    return {
      key: '',
      allocated: [], // 已分配
      leadIds: [],
      btnLoading: false,
      loading: false,
      tableLoading: false,
      sumData: 0, // 待分配人数
      pageNum: 1,
      pageSize: 10,
      tableData: [], // 分页列表
      sumList: [], // 总列表
      value: [], // 选中的部门、人员集合
      props: { multiple: true, label: 'value', value: 'info', children: 'childList' },
      options: [], // type 类型 1：部门 2：员工
      visibleDialog: false
    }
  },
  computed: {
  },
  directives: {
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    batchDispatchLead() {
      var data = {}
      data.leadsIds = this.leadIds.map(x => { return x.id })
      data.staffs = this.sumList.map(x => {
        return {
          ownerId: x.id,
          ownerName: x.value
        }
      })
      this.btnLoading = true
      batchDispatchLead(data).then(res => {
        this.btnLoading = false
        if (res.code == '0') {
          this.$emit('getData')
          this.visibleDialog = false
          this.$message.success('分配成功')
        }
      }).catch(_ => { this.btnLoading = false })
    },
    getOptions(arr) {
      if (arr && arr.length) {
        arr.forEach(e => {
          this.$set(e, 'disabled', false)
          this.$set(e, 'info', {
            value: e.value,
            id: e.id,
            containFlag: e.containFlag,
            todayDispatchCount: e.todayDispatchCount || 0
          })
          if (e.type == 2) {
            delete e.childList
          }
          if (e.type == 1 && (e.childList == undefined || e.childList == null || !e.childList || !e.childList.length || e.containFlag !== 1)) {
            e.disabled = true
          }
          if (e.childList && e.childList.length) {
            this.getOptions(e.childList)
          } else {
            delete e.childList
          }
        })
      }
    },
    getTodayHasDispatched() {
      this.loading = true
      getTodayHasDispatched().then(res => {
        this.loading = false
        this.options = res.data
        this.getOptions(this.options)
      }).catch(_ => { this.loading = false })
    },
    clickDel(row) {
      this.key = new Date().getTime()
      this.value = this.value.filter(e => row.id !== e[e.length - 1].id)
      this.changeCascader()
      // for (let i = 0; i < this.value.length; i++) {
      //   const e = this.value[i]
      //   if (row.id === e[e.length - 1].id) {
      //     this.value.splice(i, 1)
      //     i--
      //   }
      // }
      this.$forceUpdate()
    },
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(i) {
      this.pageNum = i
      this.getTableData()
    },
    getTableData() {
      const begin = (this.pageNum - 1) * this.pageSize
      const end = this.pageNum * this.pageSize
      this.tableData = this.sumList.slice(begin, end)
      if (this.pageNum > 1 && this.tableData.length === 0) {
        this.pageNum--
        this.getTableData()
      }
    },
    changeCascader() {
      this.sumList = []
      this.value.forEach(e => {
        const item = { ...e[e.length - 1], ...{ disNum: 0 } }
        this.sumList.push(item)
      })
      this.sumList = reduceSame(this.sumList)
      this.sumList.forEach((e, i) => {
        this.$set(e, 'sort', i + 1)
      })
      this.tableData = []
      if (!this.sumList.length) return
      this.getDisNum()
      this.$forceUpdate()
      this.getTableData()
    },
    getDisNum() {
      const base = Math.floor(this.sumData / this.sumList.length)
      const rest = this.sumData % this.sumList.length
      this.sumList.forEach((e, i) => {
        e.disNum = base + (i < rest ? 1 : 0)
      })
    },
    openDialog(list) {
      this.value = []
      this.sumList = []
      this.tableData = []
      this.leadIds = list
      this.sumData = 0
      this.pageNum = 1
      this.pageSize = 10
      this.allocated = []
      list.forEach(e => {
        if (e.leadState == 0) { // 待分配
          // this.leadIds.push(e)
        } else { // 已分配
          this.allocated.push(e)
        }
      })
      this.sumData = this.leadIds.length
      this.getTodayHasDispatched()
      this.visibleDialog = true
    },
    closeDialog() {
      this.visibleDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}
.mb-16 {
  margin-bottom: 16px;
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}
/deep/ .el-cascader__search-input {
  min-width: 40px !important;
}
/deep/ .el-dialog__body {
  max-height: 500px;
  overflow: auto;
}
/deep/.el-dialog__footer {
  // text-align: center;
}
</style>
